/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import {
  FormFlex,
  FormFlexDiv,
  TabContentWrapper,
  SmallHeader,
} from "../../pages/Dashboard/styles/dashboard.style";
import { InputWrapper } from "../../pages/auth/Login.style";
import { useSelector } from "react-redux";
import avatar from "../../assets/Images/avatar.jpg";
import colors from "../../assets/colors.json";
import Select from "../select/select";
import DatePickerComponent from "../datepicker/DatePicker";
import PropTypes from "prop-types";
import { LabelWrapper, SmallText } from "../../pages/auth/auth.style";
import Upload from "../../assets/icons/upload";
import { convertToBase64, getNigeriaDateTime } from "../../utils";
import { personalData, updatePersonalData } from "../../services/user";
import { toast } from "react-toastify";

const Personal = ({ status }) => {
  const [dob, setDob] = useState(new Date(2014, 0, 3));
  const [age, setAge] = useState("");
  const [terms, setTerms] = useState(false);
  const [details, setDetails] = useState(null);
  const [staffNumber, setStaffNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [data, setData] = useState(null);
  const { user, admToken } = useSelector((state) => state.auth);
  const [access, setAccess] = useState(null);
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedPic, setSelectedPic] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviewPic, setImagePreviewPic] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    staffId: 0,
    surName: "",
    otherName: "",
    profileImageurl: "",
    staffNumber: "",
    email: "",
    address: "",
    dob: null,
    age: 0,
    phone: "",
    bgroup: "",
    genotype: "",
    religion: "",
    marital: "",
    origin: "",
    language: "",
    gender: "",
    medicalHistory: "",
    alergy: "",
    status: 0,
    cadre: "",
    maidenName: "",
    spouseName: "",
    spouseOccupation: "",
    denomination: "",
    hobbies: "",
    signature: "",
  });

  const currentDateTime = new Date().toISOString();

  const getProfile = useCallback(async () => {
    try {
      setLoadingProfile(true);
      const res = await personalData(admToken, user?.staffId);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
      } else {
        setData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingProfile(false);
    }
  }, [admToken, user?.staffId]);

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (data) {
      setForm({
        firstName: data?.firstName || "",
        staffId: data?.staffId || 0,
        surName: data?.surName || "",
        otherName: data?.otherName || "",
        profileImageurl: data?.profileImageurl || "",
        staffNumber: data?.staffNumber || "",
        email: data?.email || "",
        address: data?.address || "",
        dob: data?.dob ? new Date(data.dob).toISOString() : null,
        age: data?.age || 0,
        phone: data?.phone || "",
        bgroup: data?.bgroup || "",
        genotype: data?.genotype || "",
        religion: data?.religion || "",
        marital: data?.marital || "",
        origin: data?.origin || "",
        language: data?.language || "",
        gender: data?.gender || "",
        medicalHistory: data?.medicalHistory || "",
        alergy: data?.alergy || "",
        status: data?.status || 0,
        cadre: data?.cadre || "",
        maidenName: data?.maidenName || "",
        spouseName: data?.spouseName || "",
        spouseOccupation: data?.spouseOccupation || "",
        denomination: data?.denomination || "",
        hobbies: data?.hobbies || "",
        signature: data?.signature || "",
      });
    }
  }, [data]);

  useEffect(() => {
    if (data !== null) {
      setDetails(Object.assign({}, data.accountDetails));
      setAccess(Object.assign({}, data.accountAccess));
    }
  }, [data]);

  const fetchStaffNumber = useCallback(async (admToken) => {
    try {
      const endpoint = `https://lasmabadmindev.azurewebsites.net/api/v1/UserAccount/Staff-Profile`;
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${admToken}`,
        },
      });

      if (response.data.status === true && response.data.statusCode === 2) {
        return response.data.data;
      } else {
        throw new Error("Failed to fetch staff number");
      }
    } catch (error) {
      console.error("Error fetching staff number:", error);
      throw error;
    }
  }, []);

  useEffect(() => {
    const getStaffNumber = async () => {
      setLoading(true);
      try {
        const data = await fetchStaffNumber(admToken, user.staffId);
        if (
          data &&
          data.userInformation &&
          data.userInformation.accountDetails
        ) {
          setStaffNumber(data.userInformation.accountDetails.staffNumber);
        } else {
          console.error("Invalid response structure");
        }
      } catch (error) {
        console.error("Error fetching staff number");
      } finally {
        setLoading(false);
      }
    };

    getStaffNumber();
  }, [admToken, user.staffId, fetchStaffNumber]);

  const optGender = [
    {
      id: 1,
      name: "MALE",
    },
    {
      id: 2,
      name: "FEMALE",
    },
    {
      id: 3,
      name: "Male",
    },
    {
      id: 4,
      name: "Female",
    },
    {
      id: 5,
      name: "male",
    },
    {
      id: 6,
      name: "female",
    },
  ];

  const calculateAge = (date = dob) => {
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const month = today.getMonth() - date.getMonth();

    if (month < 0 || (month === 0 && today.getDate() < date.getDate())) {
      age--;
    }
    setAge(age);
  };

  useEffect(() => {
    if (data !== null) {
      setDetails(Object.assign({}, data));
      calculateAge(new Date(data.dob));
    }
  }, [data]);

  useEffect(() => {
    return () => {
      if (imagePreview) URL.revokeObjectURL(imagePreview);
    };
  }, [imagePreview]);

  const handleFileIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (imagePreview) URL.revokeObjectURL(imagePreview);

    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);

    const base64String = await convertToBase64(file);
    setSelectedFile(base64String);
  };

  const handleFileChangeImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (imagePreviewPic) URL.revokeObjectURL(imagePreviewPic);

    const previewUrl = URL.createObjectURL(file);
    setImagePreviewPic(previewUrl);

    const base64String = await convertToBase64(file);
    setSelectedPic(base64String);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        firstName: form.firstName,
        staffId: form.staffId,
        surName: form.surName,
        otherName: form.otherName,
        profileImageurl: selectedPic || form.profileImageurl,
        staffNumber: form.staffNumber,
        email: form.email,
        address: form.address,
        dob: dob,
        age: age,
        phone: form.phone,
        bgroup: form.bgroup,
        genotype: form.genotype,
        religion: form.religion,
        marital: form.marital,
        origin: form.origin,
        language: form.language,
        gender: form.gender,
        medicalHistory: form.medicalHistory,
        alergy: form.alergy,
        status: form.status,
        cadre: form.cadre,
        maidenName: form.maidenName,
        spouseName: form.spouseName,
        spouseOccupation: form.spouseOccupation,
        denomination: form.denomination,
        hobbies: form.hobbies,
        signature: selectedFile || form.signature,
        currentDateTime: currentDateTime,
      };
      setLoadingUploading(true);
      const res = await updatePersonalData(admToken, payload, user?.staffId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        getProfile();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false);
    }
  };

  return (
    <TabContentWrapper>
      {details === null ? (
        <SmallHeader
          style={{
            textAlign: "center",
            color: colors.primary,
            fontWeight: "bold",
          }}
        >
          An error Ocurred Try Again Later
        </SmallHeader>
      ) : (
        <>
          <FormFlex reverse={true}>
            <FormFlexDiv>
              {" "}
              <InputWrapper>
                <label htmlFor="Surname">Surname</label>
                <input
                  type="text"
                  placeholder="Surname"
                  value={form.surName}
                  onChange={(e) =>
                    setForm({ ...form, surName: e.target.value })
                  }
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="First Name">First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  value={form.firstName}
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  onChange={(e) =>
                    setForm({ ...form, firstName: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Other Name">Other Name</label>
                <input
                  type="text"
                  placeholder="Other Name"
                  value={form.otherName}
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  onChange={(e) =>
                    setForm({ ...form, otherName: e.target.value })
                  }
                />
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <div className="flex item-center justify-center">
                <div className="h-[230px] w-[230px] rounded-md overflow-hidden">
                  <div
                    className="relative h-full cursor-pointer"
                    onClick={handleImageClick}
                  >
                    <div className="overflow-hidden">
                      <input
                        type="file"
                        ref={imageInputRef}
                        onChange={handleFileChangeImage}
                        accept="image/jpeg"
                        hidden
                      />

                      {imagePreviewPic || data?.profileImageurl ? (
                        <img
                          src={
                            imagePreviewPic ??
                            data?.profileImageurl ??
                            "https://placehold.co/200x200?text=No+Images"
                          }
                          alt="profile"
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                          <img
                            src={avatar}
                            alt="profile"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className="w-full h-[50px] bg-white flex items-center justify-center cursor-pointer border border-gray-200"
                    onClick={handleImageClick}
                  >
                    <Upload />
                  </div>
                </div>
              </div>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="Maiden Nam">Maiden Name</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Maiden Name"
                  value={form.maidenName}
                  onChange={(e) =>
                    setForm({ ...form, maidenName: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Spouse Name">Spouse Name</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Spouse Name"
                  value={form.spouseName}
                  onChange={(e) =>
                    setForm({ ...form, spouseName: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Spouse Name">Spouse Occupation</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Spouse Occupation"
                  value={form.spouseOccupation}
                  onChange={(e) =>
                    setForm({ ...form, spouseOccupation: e.target.value })
                  }
                />
              </InputWrapper>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                  }}
                >
                  <InputWrapper>
                    <label htmlFor="">Date of Birth</label>

                    <DatePickerComponent
                      disabled={
                        !(status === 0 || status === 4) || loadingProfile
                      }
                      selected={form.dob ? new Date(form.dob) : null}
                      setSelected={(val) => {
                        setDob(val);
                        setForm({ ...form, dob: val.toISOString() });
                        calculateAge(val);
                      }}
                    />
                  </InputWrapper>
                </div>
                <div
                  style={{
                    width: "20%",
                  }}
                >
                  <InputWrapper>
                    <label
                      htmlFor="Age"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      Age
                    </label>
                    <input
                      type="text"
                      value={form.age}
                      style={{
                        color: "black",
                        background: colors.lightGray,
                        borderColor: colors.lightGray,
                      }}
                      disabled={
                        !(status === 0 || status === 4) || loadingProfile
                      }
                      onChange={(e) =>
                        setForm({ ...form, age: e.target.value })
                      }
                    />
                  </InputWrapper>
                </div>
              </div>
              <InputWrapper>
                <label htmlFor="Denomination">Denomination</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Denomination"
                  value={form.denomination}
                  onChange={(e) =>
                    setForm({ ...form, denomination: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Hobbies">Hobbies</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Hobbies"
                  value={form.hobbies}
                  onChange={(e) =>
                    setForm({ ...form, hobbies: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Religion">Marital Status</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Marital Status"
                  value={form.marital}
                  onChange={(e) =>
                    setForm({ ...form, marital: e.target.value })
                  }
                />
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="Other Name">LASMAB Number</label>
                <input
                  type="text"
                  placeholder="Staff Number"
                  value={staffNumber}
                  disabled
                  onChange={(e) =>
                    setForm({ ...form, staffNumber: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  placeholder="Enter Email"
                  value={form.email}
                  disabled
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Phone Number">Phone Number</label>
                <input
                  type="text"
                  disabled
                  placeholder="Enter Phone Number"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Language Spoken">Language Spoken</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Language"
                  value={form.language}
                  onChange={(e) =>
                    setForm({ ...form, language: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Blood Group">Blood Group</label>
                <input
                  type="text"
                  placeholder="Enter Blod Group"
                  value={form.bgroup}
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  onChange={(e) => setForm({ ...form, bgroup: e.target.value })}
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Blood Genotype">Blood Genotype</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Blood Genotype"
                  value={form.genotype}
                  onChange={(e) =>
                    setForm({ ...form, genotype: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Gender">Gender</label>
                <Select
                  title="Gender"
                  index="name"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  selected={form.gender}
                  options={optGender}
                  setSelected={(val) => {
                    setForm({ ...form, gender: val.name });
                  }}
                />
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="Religion">Religion</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter Religion"
                  value={form.religion}
                  onChange={(e) =>
                    setForm({ ...form, religion: e.target.value })
                  }
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="origin">State Of Origin</label>
                <input
                  type="text"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  placeholder="Enter State Of Origin"
                  value={form.origin}
                  onChange={(e) => setForm({ ...form, origin: e.target.value })}
                />
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="address">Cadre</label>
                <input
                  type="text"
                  placeholder="Enter Address"
                  disabled
                  value={form.cadre}
                  onChange={(e) => setForm({ ...form, cadre: e.target.value })}
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  placeholder="Enter Address"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  value={form.address}
                  onChange={(e) =>
                    setForm({ ...form, address: e.target.value })
                  }
                />
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="medical history">Medical History</label>
                <textarea
                  cols="30"
                  rows="3"
                  placeholder={form.medicalHistory}
                  value={form.medicalHistory}
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  onChange={(e) =>
                    setForm({ ...form, medicalHistory: e.target.value })
                  }
                ></textarea>
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="">
                  Physical Disability/Allergy/Serious Illness
                </label>
                <textarea
                  cols="30"
                  rows="3"
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                  value={form.alergy}
                  onChange={(e) => setForm({ ...form, alergy: e.target.value })}
                ></textarea>
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="">Signature</label>
                <div
                  className="relative w-28 h-28 md:w-full md:h-36 bg-gray-100 mt-2 mb-4"
                  onClick={handleFileIconClick}
                  disabled={!(status === 0 || status === 4) || loadingProfile}
                >
                  <div className="h-full md:w-full md:h-36 bg-gray-100 flex items-center justify-center border border-dashed border-primary overflow-hidden rounded-lg">
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      accept="image/jpeg"
                      hidden
                      disabled={
                        !(status === 0 || status === 4) || loadingProfile
                      }
                    />

                    {imagePreview || data?.signature ? (
                      <img
                        src={
                          imagePreview ??
                          data?.signature ??
                          "https://placehold.co/200x200?text=No+Images"
                        }
                        alt="signature"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                        <Upload />
                        <label>Click to upload your Signature</label>
                      </div>
                    )}
                  </div>

                  <label>Upload jpeg file only</label>
                </div>
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="" className="px-4">
                  Date and Time
                </label>
                <p className="mb-2 px-4">
                  {currentDateTime ? getNigeriaDateTime(currentDateTime) : "-"}
                </p>
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <InputWrapper
            style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
          >
            <LabelWrapper>
              <input
                style={{
                  width: "auto",
                  borderRadius: "50%",
                }}
                type="checkbox"
                value={terms}
                onChange={() => setTerms(!terms)}
              />
              <span></span>
            </LabelWrapper>

            <div
              style={{
                marginLeft: "7px",
                fontWeight: "bold",
                fontStyle: "Gilroy-Bold",
              }}
            >
              <SmallText color={colors.gray}>
                I hereby declare that the above information about me is correct
                and true
              </SmallText>
            </div>
          </InputWrapper>
          {status === 4 ||
            (status === 0 && (
              <div className="flex items-center justify-center my-7">
                <button
                  disabled={!terms || loadingUploading}
                  onClick={handleUpdate}
                  className="px-8 py-2.5 rounded-lg text-white bg-primary disabled:cursor-not-allowed disabled:bg-gray-300"
                >
                  {loadingUploading ? "Updating" : "Update"}
                </button>
              </div>
            ))}
        </>
      )}
    </TabContentWrapper>
  );
};

Personal.propTypes = {
  data: PropTypes.object,
};

Personal.defaultProps = {
  data: null,
};

export default Personal;
